import { reduxStoreTypes } from '@type/redux-store';

export const SET_BUTTONS: reduxStoreTypes.ButtonsType = 'SET_BUTTONS';
export const GET_BUTTONS: reduxStoreTypes.ButtonsType = 'GET_BUTTONS';
export const setButtons = (params: Omit<reduxStoreTypes.ButtonAction, 'type'>) => ({
    type: SET_BUTTONS,
    ...params
})

export const getButtons = (params: Omit<reduxStoreTypes.ButtonAction, 'type'>) => ({
    type: GET_BUTTONS,
    ...params
})